<template>
    <div class="row">
        <div class="col-12">
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿Está segur@ de pagar el plazo ahora?</h1>
                <div class="form-group mt-4">
                    <label class="text-left">Método de pago</label>
                    <ValidationProvider name="metodo de pago" id="metodo_pago" rules="required" v-slot="{ errors }">
                        <multiselect 
                            v-model="metodo_pago"
                            id="metodo_pago"
                            placeholder="Método de pago"
                            :class="'col-12 p-0 ' + (errors[0] ? ' is-invalid' : '')"
                            label="nombre"
                            :multiple="false" 
                            :options="metodos_pago"
                        />
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>

                <h5 class="p-2">
                    Importe a pagar: <h3>{{ importe | formatear_precio }}</h3>             
                </h5>
                <div class="col-12 text-center">
                    <Button name="button" class="mr-1" :disabled="!metodo_pago" @click="pagar">Pagar</Button>
                    <Button type="button" name="button" @click="$emit('close')">Cancelar</Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['importe'],
        data() {
            return {
                metodo_pago: null,
                metodos_pago : null
            }
        },
        created() {
            this.metodos_pago = this.teatro.metodos_pago_abonos_bases.slice();

            this.borrarMetodoDePago(this.metodos_pago, 5);
            this.borrarMetodoDePago(this.metodos_pago, 8);
            this.borrarMetodoDePago(this.metodos_pago, 9);
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            pagar() {
                this.$emit('terminado', this.metodo_pago.id)
            },
            borrarMetodoDePago(metodos_de_pago, id) {
                const metodo_pago_id = metodos_de_pago.findIndex(metodo_de_pago => metodo_de_pago.id === id);
                metodos_de_pago.splice(metodo_pago_id, 1);
                return metodos_de_pago;
            }
        }
    }
</script>
